import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { Table } from "semantic-ui-react";
import { ventasOps } from "../../../../../ducks/ventas";
import FilaAcciones from "./tablaAcciones/FilaAcciones";

class TablaAcciones extends Component {
  componentDidMount() {
    this.props.attachAccionesDeVenta({
      idColegio: this.props.idColegio,
      tipo: "general"
    });
  }

  componentWillUnmount() {
    this.props.detachAccionesDeVenta({ idColegio: this.props.idColegio });
  }

  render() {
    const datos = this.props.accionesDeVenta.filter(
      ({ idColegio }) => idColegio === this.props.idColegio
    );

    return (
      <Table basic selectable>
        <Table.Body>
          {datos.map(dato => (
            <FilaAcciones
              key={dato.idAccion}
              datos={dato}
              cambiarResultadoAccion={this.props.cambiarResultadoAccion}
              cerrarAccionDeVenta={this.props.cerrarAccionDeVenta}
              guardarNota={this.props.guardarNotaAccionDeVenta}
            />
          ))}
        </Table.Body>
      </Table>
    );
  }
}

const toProps = state => ({
  uid: state.session.user.uid,
  accionesDeVenta: state.ventas.accionesDeVenta
});

const actions = {
  attachAccionesDeVenta: ventasOps.attachAccionesDeVenta,
  detachAccionesDeVenta: ventasOps.detachAccionesDeVenta,
  cambiarResultadoAccion: ventasOps.cambiarResultadoAccion,
  cerrarAccionDeVenta: ventasOps.cerrarAccionDeVenta,
  guardarNotaAccionDeVenta: ventasOps.guardarNotaAccionDeVenta
};

export default connect(toProps, actions)(withRouter(TablaAcciones));



// WEBPACK FOOTER //
// ./src/pages/ventas/ventas/tablaColegios/filaColegios/TablaAcciones.jsx